import * as news from './endpoints/news';
import * as contact from './endpoints/contact';
import * as calendar from './endpoints/calendar';
import * as racehub from './endpoints/racehub';
import * as riders from './endpoints/riders';
import * as rankings from './endpoints/rankings';

export default {
  news,
  contact,
  calendar,
  racehub,
  riders,
  rankings,
};
